export const numericRegex = /^[0-9]*$/;

export const urlRegex = /(https?:\/\/[^\s]+)/g;

export const booleanRegex = /^true$/i;